"use client";
import {
  selectData
} from "./chunk-5RJ4DDVN.mjs";

// src/hidden-select.tsx
import { useFormReset } from "@react-aria/utils";
import { useInteractionModality } from "@react-aria/interactions";
import { useVisuallyHidden } from "@react-aria/visually-hidden";
import { useFormValidation } from "@react-aria/form";
import { jsx, jsxs } from "react/jsx-runtime";
function useHiddenSelect(props, state, triggerRef) {
  var _a;
  let data = selectData.get(state) || {};
  let {
    autoComplete,
    name = data.name,
    isDisabled = data.isDisabled,
    selectionMode,
    onChange
  } = props;
  let { validationBehavior, isRequired } = data;
  let modality = useInteractionModality();
  let { visuallyHiddenProps } = useVisuallyHidden();
  useFormReset(props.selectRef, state.selectedKeys, state.setSelectedKeys);
  useFormValidation(
    {
      validationBehavior,
      focus: () => {
        var _a2;
        return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
      }
    },
    state,
    props.selectRef
  );
  return {
    containerProps: {
      ...visuallyHiddenProps,
      "aria-hidden": true,
      ["data-a11y-ignore"]: "aria-hidden-focus"
    },
    inputProps: {
      type: "text",
      tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
      autoComplete,
      value: (_a = [...state.selectedKeys].join(",")) != null ? _a : "",
      required: isRequired,
      style: { fontSize: 16 },
      onFocus: () => {
        var _a2;
        return (_a2 = triggerRef.current) == null ? void 0 : _a2.focus();
      },
      disabled: isDisabled,
      onChange: () => {
      }
    },
    selectProps: {
      name,
      tabIndex: -1,
      autoComplete,
      disabled: isDisabled,
      size: state.collection.size,
      value: selectionMode === "multiple" ? [...state.selectedKeys].map((k) => String(k)) : [...state.selectedKeys][0],
      multiple: selectionMode === "multiple",
      onChange: (e) => {
        state.setSelectedKeys(e.target.value);
        onChange == null ? void 0 : onChange(e);
      }
    }
  };
}
function HiddenSelect(props) {
  var _a;
  let { state, triggerRef, selectRef, label, name, isDisabled } = props;
  let { containerProps, inputProps, selectProps } = useHiddenSelect(
    { ...props, selectRef },
    state,
    triggerRef
  );
  if (state.collection.size <= 300) {
    return /* @__PURE__ */ jsxs("div", { ...containerProps, "data-testid": "hidden-select-container", children: [
      /* @__PURE__ */ jsx("input", { ...inputProps }),
      /* @__PURE__ */ jsxs("label", { children: [
        label,
        /* @__PURE__ */ jsxs("select", { ...selectProps, ref: selectRef, children: [
          /* @__PURE__ */ jsx("option", {}),
          [...state.collection.getKeys()].map((key) => {
            let item = state.collection.getItem(key);
            if ((item == null ? void 0 : item.type) === "item") {
              return /* @__PURE__ */ jsx("option", { value: item.key, children: item.textValue }, item.key);
            }
          })
        ] })
      ] })
    ] });
  } else if (name) {
    return /* @__PURE__ */ jsx(
      "input",
      {
        autoComplete: selectProps.autoComplete,
        disabled: isDisabled,
        name,
        type: "hidden",
        value: (_a = [...state.selectedKeys].join(",")) != null ? _a : ""
      }
    );
  }
  return null;
}

export {
  useHiddenSelect,
  HiddenSelect
};
